import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics Measurement ID - à configurer dans .env
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Initialize Google Analytics
export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.warn('Google Analytics ID not configured');
    return;
  }

  // Load gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false, // We'll handle page views manually
  });
};

// Track page views
export const trackPageView = (path) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, eventParams);
  }
};

// Predefined events for the nursing site
export const trackPhoneClick = () => {
  trackEvent('phone_click', {
    event_category: 'Contact',
    event_label: 'Phone Number Click',
  });
};

export const trackEmailClick = () => {
  trackEvent('email_click', {
    event_category: 'Contact',
    event_label: 'Email Click',
  });
};

export const trackFormSubmit = (formType) => {
  trackEvent('form_submit', {
    event_category: 'Conversion',
    event_label: formType,
  });
};

export const trackServiceClick = (serviceName) => {
  trackEvent('service_click', {
    event_category: 'Engagement',
    event_label: serviceName,
  });
};

export const trackCTAClick = (ctaLocation) => {
  trackEvent('cta_click', {
    event_category: 'Engagement',
    event_label: ctaLocation,
  });
};

// Hook to track page views automatically
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
};

// Component to initialize GA
export const GoogleAnalytics = () => {
  useEffect(() => {
    initGA();
  }, []);

  return null;
};
